import { useState } from "react";
import { useForm } from "react-hook-form";
import { User } from "../models/FormModels";

const defaultValues = {
  projectName: "",
  costCenter: "",
  hideProject: false,
  opcoCrossCharginInformation: "",
  billingType: "CostCenter",
  packageId: "",
  packageCustomField: {},
  users: [],
  tools: [],
  teamMembersManualApproval: true,
  stakeholdersManualApproval: true,
  jiraWorkflowScheme: "",
};

export type ProjectFormType = typeof defaultValues & {
  packageCustomField: Record<string, any>;
  users: User[];
  tools: Record<string, any>[];
  opcoId?: string;
  jiraWorkflowScheme: string;
};

const useCreateProject = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [advanceAllowed, setAdvanceAllowed] = useState(true);
  const form = useForm({ 
    defaultValues, 
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  return {
    activeStep,
    setActiveStep,
    advanceAllowed,
    setAdvanceAllowed,
    form,
  };
};

export default useCreateProject;
